import { roundAmount } from '@features/reconciliation/utils/roundAmount'
import { BankLine } from '@modules-deprecated/bankReconciliation/types'

export const getTransactionAmount = (selectedTransaction: BankLine, combinedTransactions: BankLine[] = []): number => {
  if (combinedTransactions.length === 0) {
    return selectedTransaction.amount
  }

  let total = selectedTransaction.amount

  for (const transaction of combinedTransactions) {
    const sign = transaction.side === selectedTransaction.side ? 1 : -1
    total += sign * transaction.amount
  }

  return roundAmount(total)
}
